export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "hubs-v2" */ '@app2/modules/Dashboard/Pages/Index'),
  },
];
